import type { Capture } from '@/types';
import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { InboxContent } from './InboxContent';

interface InboxPanelProps {
  captures: Capture[];
  onConvertToTask: (capture: Capture) => void;
  onConvertToBlock: (capture: Capture) => void;
  onArchive: (captureId: string) => void;
  onDelete: (captureId: string) => void;
}

export function InboxPanel({
  captures,
  onConvertToTask,
  onConvertToBlock,
  onArchive,
  onDelete,
}: InboxPanelProps) {
  const inboxCount = captures.filter((c) => c.status === 'inbox').length;
  const title = inboxCount > 0 ? `Inbox (${inboxCount})` : 'Inbox';

  return (
    <ResponsivePanelWrapper panelId="inbox" title={title}>
      <InboxContent
        captures={captures}
        onConvertToTask={onConvertToTask}
        onConvertToBlock={onConvertToBlock}
        onArchive={onArchive}
        onDelete={onDelete}
      />
    </ResponsivePanelWrapper>
  );
}

export default InboxPanel;
